import React from "react";
import classnames from "classnames";
import "./style.css";
type ButtonProps = React.HTMLProps<HTMLButtonElement> & {
  small?: boolean;
  variant?: "default" | "secondary";
};

const Button = ({ children, small, variant, ...rest }: ButtonProps) => {
  return (
    <button
      {...rest}
      type="button"
      className={classnames({
        "yc-button": true,
        small,
        secondary: variant === "secondary",
      })}
    >
      {children}
    </button>
  );
};

export default Button;
